// 配置文件-极酷、汕头移动版本
// var address = 'http://47.106.238.136/wms/index.php';//http://v4.geeku.top:8020

// var clientPort = '111118'
// var serverPort = '47.106.238.136'//开发：47.106.238.136，测试：47.106.146.148，正式：47.107.118.123
// var deviceId = '111118'

var commonAddress = ''

var commomHeaders = {
	'Content-Type': 'application/json'
}

var configStorage = JSON.parse(localStorage.getItem('configStorage'))
var address = '', address2 = '', clientPort = '', serverPort = '', serverPort2 = '', deviceId = '', mqttInfo= {};

/* 应用极酷-开始部分 */
// 主题地址（正式、测试），通讯地址（正式、测试）
var zip = '47.107.118.123', cip = '47.106.146.148', zdn = 'cps.geekuiot.com', cdn = 'cps-test.geekuiot.com'
/* 应用极酷-结束部分 */

/* 应用汕头移动-开始部分 */
// 主题地址（正式、测试）
// var zip = '47.107.118.123', cip = '47.106.146.148'
// // 通讯地址（极酷正式、极酷测试、汕头移动正式）
// var zdn = 'cps.geekuiot.com', cdn = 'cps-test.geekuiot.com', zdn_stcmcc = 'cmccshantou-cps.geekuiot.com'
/* 应用汕头移动-结束部分 */

if(configStorage){
	address = configStorage.address
	address2 = configStorage.address2
	
	clientPort = configStorage.deviceId

	serverPort = configStorage.serverPort
	// serverPort2 = configStorage.serverPort2

	deviceId = configStorage.deviceId

	serverPort2 = configStorage.serverPort == zip || configStorage.serverPort == zdn ? zip : cip // 应用极酷
	// serverPort2 = configStorage.serverPort == zip || configStorage.serverPort == zdn || configStorage.serverPort == zdn_stcmcc ? zip : cip  // 应用汕头移动
	var mqtt40 = {
		userName: 'admin',
		password: 'admin',
		port: 61614,//端口号
		clientId: deviceId + (new Date()).getTime(),//clientId（不能重复）
	}
	var mqtt40s = {
		userName: 'Terminal996',
		password: 'Cryptogram@20',
		port: 61624,//端口号
		clientId: 'PAD_' + deviceId,//clientId（不能重复）
	}
	mqttInfo = configStorage.serverPort == zip ? mqtt40 : mqtt40s
}
// console.log('mqttInfo', mqttInfo, serverPort2)

export {
	address,
	address2,

	commonAddress,
	commomHeaders,
	clientPort,

	serverPort,
	serverPort2,
	
	deviceId,

	mqttInfo
}


//////////////////
// WEBPACK FOOTER
// ./static/js/config.js
// module id = wAX/
// module chunks = 1